// @ts-nocheck

import networkActions from '../../actions/network';

import { setHistoryFetching } from './actions/history';
import { getCurrentPageOffset, getFilter } from './selectors/history';
import { GridsActionTypes } from './types/actions';

export default ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    switch (action.type) {
      case GridsActionTypes.INIT: {
        dispatch(networkActions.send({ grids: { command: 'getInitialState' } }));
        break;
      }
      case GridsActionTypes.ASK_POOL: {
        const { poolId } = action.payload;
        // 7001825
        dispatch(networkActions.send({ grids: { command: 'getPool', poolId } }));
        break;
      }
      case GridsActionTypes.ASK_HISTORY_GRID: {
        const { gridReference } = action.payload;
        // 28HIX-47GKP8KK
        dispatch(networkActions.send({ grids: { command: 'getGrid', gridReference } }));
        break;
      }
      case GridsActionTypes.ASK_PUBLIC_GRIDS: {
        const { poolId } = action.payload;
        dispatch(networkActions.send({ grids: { command: 'getPublicGrids', poolId } }));
        break;
      }
      default:
        break;
    }

    const nextValue = next(action);

    switch (action.type) {
      case GridsActionTypes.SET_HISTORY_FILTER:
      case GridsActionTypes.ASK_HISTORY_GRIDS:
      case GridsActionTypes.SET_HISTORY_PAGE: {
        const state = getState();
        const { connected } = state.user;
        if (connected) {
          dispatch(setHistoryFetching(true));
          const offset = getCurrentPageOffset(state);
          const filter = getFilter(state);
          dispatch(networkActions.send({ grids: { command: 'getGrids', offset, filter } }));
        }
        break;
      }
      default:
        break;
    }

    return nextValue;
  };
